var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "container" }, [
    _c(
      "div",
      {
        staticClass: "card email-card",
        attrs: {
          "data-email-id": _vm.id,
          "data-thread-id": _vm.threadId,
          "data-message-id": _vm.messageId,
        },
      },
      [
        _c("div", { staticClass: "card-header" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-7" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "d-flex align-items-center" }, [
                    _vm.subject
                      ? _c("h4", { staticClass: "bold mb-0" }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.subject) +
                              "\n                "
                          ),
                        ])
                      : _c(
                          "h4",
                          {
                            staticClass:
                              "font-italic font-weight-light text-light-gray mb-0",
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("email.noSubject")) +
                                "\n                "
                            ),
                          ]
                        ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "bold font-sm text-light-gray mb-1" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm._f("momentLocal")(
                              _vm.createdAt,
                              "MMM. DD, YYYY LT"
                            )
                          ) +
                          "\n              "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "bold d-inline-block" }, [
                    _vm._v(_vm._s(_vm.$t("email.from")) + ": "),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "font-sm text-light-gray bold" }, [
                    _vm._v(_vm._s(_vm.fromName)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "font-sm text-light-gray" }, [
                    _vm._v("<" + _vm._s(_vm.fromEmail) + ">"),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 show-email-cc-wrapper" },
                  [
                    _vm.ccList.list[0] || _vm.bccList.list[0]
                      ? _c(
                          "a",
                          {
                            staticClass: "clickable show-email-cc",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.showEmailCC($event)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-caret-down",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("timeline-email-contact-list", {
                      attrs: {
                        label: _vm.$t("email.to") + ": ",
                        "contact-list": _vm.toList.list,
                      },
                    }),
                    _vm._v(" "),
                    _vm.ccList.list[0] || _vm.bccList.list[0]
                      ? _c(
                          "div",
                          {
                            staticClass: "show-email-cc-target",
                            staticStyle: { display: "none" },
                          },
                          [
                            _vm.ccList.list[0]
                              ? _c(
                                  "div",
                                  [
                                    _c("timeline-email-contact-list", {
                                      attrs: {
                                        label: _vm.$t("email.cc") + ":",
                                        "contact-list": _vm.ccList.list,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", {
          ref: "emailWrapper",
          staticClass: "card-body p-0",
          attrs: { id: "email-" + _vm.id },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }